<script>
import {mapState} from "vuex";
import {EF_TRACKING_URL} from "@/paths/constants";

/* FIXME: Bug => where when user inputs address on address component we override the zipcode that we receive in the Zip
    component and override that zip in the url
*/


export default {
  props: {
    prepare: {
      type: Boolean,
      default: false,
    },
    customProps: {
      type: Object,
      default: () => ({}),
    }
  },

  data() {
    return {
      inputZip: '',
      loading: false,
      address: "",
      raw_address: "",
      state: "",
      state_2letters: "",
      county: "",
      city: "",
      addressError: false,
      addressZipCode: "",
      zipCode: "",
      inputAddress: "",
      addressForValidation: {}
    };
  },

  computed: {
    ...mapState([
      "fields",
      "fieldsFromUrl",
      "fieldsFromStorage"
    ]),
  },
  mounted() {
    let address = this.fieldsFromUrl['address']
    let city = this.fieldsFromUrl['city']
    let state = this.fieldsFromUrl['state']
    let county = this.fieldsFromUrl['county']
    let rawAddress = this.fieldsFromUrl['raw_address']
    this.zipCode = this.fieldsFromUrl['zip_code']

    if (this.fieldsFromStorage['address'] !== undefined
      && this.fieldsFromStorage['city'] !== undefined
      && (this.fieldsFromStorage['state'] !== undefined || this.fieldsFromStorage['county'] !== undefined)
    ) {
      address = this.fieldsFromStorage['address']
      city = this.fieldsFromStorage['city']
      state = this.fieldsFromStorage['state']
      county = this.fieldsFromUrl['county']
    } else if (this.fieldsFromStorage['raw_address'] !== undefined) {
      rawAddress = this.fieldsFromStorage['raw_address']
    }

    if (this.prepare) {
      if ((!city || !address || (!state && !county)) && !rawAddress) {
        // this.setGoogleAutocompleteOnInput()
        this.$emit('show-this-step')
      } else {
        if (city && address && (state || county)) {
          this.getAddressByInput(`${address} ${city} ${state} ${county}, US`)
            .then(async foundAddress => {
              this.setStateFields(foundAddress, foundAddress.formatted)
              const answer = await this.setAnswer()
              console.log('answer', answer)
              if (!answer) {
                this.$emit('show-this-step')
              }
            }).catch(e => {
            console.log('error', e)
            this.$emit('show-this-step')
          })
        } else if (rawAddress) {
          this.getAddressByInput(`${rawAddress}, US`)
            .then(async foundAddress => {
              this.setStateFields(foundAddress, foundAddress.formatted)
              const answer = await this.setAnswer()
              console.log('answer', answer)
              if (!answer) {
                this.$emit('show-this-step')
              }
            }).catch(e => {
            console.log('error', e)
            this.$emit('show-this-step')
          })
        } else {
          this.$emit('show-this-step')
        }
      }
    } else {
      this.setGoogleAutocompleteOnInput()
    }
  },
  methods: {
    setStateFields(address, raw) {
      this.raw_address = raw
      this.address = `${address.home} ${address.street}`
      this.state = address.state
      this.state_2letters = address.state_2letters
      this.county = address.county
      this.city = address.city
      this.addressZipCode = address.addressZipCode
    },

    resetStateFields() {
      this.raw_address = ''
      this.address = ''
      this.state = ''
      this.state_2letters = ''
      this.county = ''
      this.city = ''
      this.addressZipCode = ''
    },

    setGoogleAutocompleteOnInput() {
      const options = {
        componentRestrictions: {country: "us"},
        fields: ['all'],
      }

      const autocomplete = new window.google.maps.places.Autocomplete(this.$refs.addressInput.$refs.input, options);

      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        const address = this.parseAddressObject(place.address_components)

        if (address) {
          this.addressForValidation = address
        }

        this.inputAddress = this.$refs.addressInput.$refs.input.value

        this.setStateFields(address, this.$refs.addressInput.$refs.input.value)
      })
    },

    getAddressByInput(input) {
      return new Promise((res, rej) => {
        try {
          const autocompleteService = new window.google.maps.places.AutocompleteService()
          autocompleteService.getPlacePredictions({input}, (predictions, status) => {
            if (status === window.google.maps.places.PlacesServiceStatus.OK) {
              const placeId = predictions[0].place_id
              const placesService = new window.google.maps.places.PlacesService(this.$refs.map)
              placesService.getDetails({
                placeId,
                fields: ["all"],
              }, resp => {
                if (resp.address_components) {
                  const address = this.parseAddressObject(resp.address_components)
                  address.formatted = resp.formatted_address
                  address.formatted = resp.formatted_address

                  this.addressForValidation = address
                  res(address)
                } else {
                  rej('no address')
                }
              })
            } else {
              rej(status)
            }
          })
        } catch (e) {
          rej(e)
        }
      })
    },

    parseAddressObject(address_components) {
      const ShouldBeComponent = {
        home: ["street_number"],
        addressZipCode: ["postal_code"],
        street: ["street_address", "route"],
        state: [
          "administrative_area_level_1",
        ],
        county: [
          "administrative_area_level_2",
        ],
        city: [
          "locality",
          "sublocality",
          "sublocality_level_1",
          "sublocality_level_2",
          "sublocality_level_3",
          "sublocality_level_4"
        ],
      };

      const address = {
        home: "",
        addressZipCode: "",
        street: "",
        state: "",
        state_2letters: "",
        county: "",
        city: "",
      }

      address_components.forEach(component => {
        for (let shouldBe in ShouldBeComponent) {
          if (ShouldBeComponent[shouldBe].indexOf(component.types[0]) !== -1) {
            if (shouldBe === "state") {
              address[shouldBe] = component.long_name;
              address.state_2letters = component.short_name;
            } else {
              address[shouldBe] = component.long_name;
            }
          }
        }
      });
      return address;
    },

    async setAnswer() {
      this.loading = true
      const valid = this.validate();
      if (!valid) {
        this.loading = false
        return false
      }

      const answers = [
        {
          field: "raw_address",
          value: this.raw_address,
        },
        {
          field: "address",
          value: this.address,
        },
        {
          field: "state",
          value: this.state,
        },
        {
          field: "state_2letters",
          value: this.state_2letters,
        },
        {
          field: "county",
          value: this.county,
        },
        {
          field: "city",
          value: this.city,
        },
        {
          field: "zip_code",
          value: this.addressZipCode,
        },
      ]

      this.$store.dispatch("setAnswers", answers)
      this.$emit("next-step");
      // await this.progressionTracking();
      return true
    },

    validate() {
      let isValid = true

      if (!this.state || !this.state_2letters) {
        this.addressError = true
        isValid = false
        return false
      }

      if (this.addressZipCode === '') {
        this.addressZipCode = this.zipCode
      }

      if (!this.addressForValidation || !this.addressForValidation.home) {
        this.addressError = true
        isValid = false
        return false
      }


      const searchParams = new URLSearchParams(location.search)
      searchParams.set('zip_code', this.addressZipCode)
      window.history.replaceState({}, null, location.pathname + '?' + searchParams.toString());
      this.$store.commit('SET_FIELDS_FROM_URL', {key: 'zip_code', value: this.addressZipCode})

      return isValid
    },

    async progressionTracking() {
      const eventID = this.customProps.trackProgress ? "40" : "62"
      await this.axios.post(`${EF_TRACKING_URL}&event_id=${eventID}&transaction_id=${this.fields['transaction_id']}`)
    },

    handleAddressChange() {
      this.addressError = false;
    },
  },
};
</script>

<template>
  <div>
    <div ref="map" class="is-hidden"/>
    <div v-if="!prepare">
      <div class="container is-max-widescreen">
        <div class="has-text-centered item-box">
          <h2 class="question mb-3 px-5">
            What is your Address?
            <span class="is-block subtitle-question">For verification only, we don't mail.</span>
          </h2>
          <div class="container is-max-widescreen px-5">
            <b-field
              :message="[
                { 'Please enter a valid address.': addressError },
              ]"
              :type="addressError ? 'is-danger' : ''"
              class="has-text-left"
            >
              <b-input
                ref="addressInput"
                v-model="inputAddress"
                class="is-normal mt-5"
                placeholder="Address"
                type="text"
                @input="handleAddressChange"
              />
            </b-field>
            <input
              :disabled="loading"
              :loading="loading"
              class="submitButton mt-3"
              type="submit"
              value="Continue"
              @click.prevent="setAnswer"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
